export const SCREENER_TABLE_COLUMNS = [
  { key: "symbol", label: "Symbol", widthPercent: 21, align: "left" as const },
  { key: "price", label: "Price", widthPercent: 7, align: "right" as const },
  {
    key: "change_percent",
    label: "Change %",
    widthPercent: 7,
    align: "right" as const,
  },
  { key: "volume", label: "Volume", widthPercent: 8, align: "right" as const },
  {
    key: "market_cap_in_cr",
    label: "Market Cap (Cr)",
    widthPercent: 10,
    align: "right" as const,
  },
  { key: "pe_ratio", label: "P/E", widthPercent: 6, align: "right" as const },
  {
    key: "eps_dil_growth",
    label: "EPS Dil Growth",
    widthPercent: 10,
    align: "right" as const,
  },
  {
    key: "dividend_yield",
    label: "Div Yield %",
    widthPercent: 8,
    align: "right" as const,
  },
  { key: "sector", label: "Sector", widthPercent: 10, align: "left" as const },
  {
    key: "industry",
    label: "Industry",
    widthPercent: 13,
    align: "left" as const,
  },
] as const;
